// useLocalizedField / localizedString — read a GM row's per-language
// text (produced by Gemini 3 Flash on save) with graceful fallback to
// the source-language value. Never throws; safe on partial/missing rows.
//
// Usage:
//   const { name } = useLocalized(enemy);
//   <span>{name}</span>
//
// or without a hook (e.g. inside a `.map` outside a component):
//   localizedString(enemy, "name", i18n.language)

import { useTranslation } from "react-i18next";

const TRANSLATABLE = ["name", "description", "lore", "flavor"];

export function localizedString(doc, field, lang) {
  if (!doc) return "";
  const t = doc.translations?.[lang];
  if (t && typeof t === "object" && t[field]) return t[field];
  return doc[field] ?? "";
}

export function localizedDoc(doc, lang) {
  if (!doc) return doc;
  const t = doc.translations?.[lang];
  if (!t || typeof t !== "object") return doc;
  const merged = { ...doc };
  for (const f of TRANSLATABLE) {
    if (t[f]) merged[f] = t[f];
  }
  return merged;
}

export function useLocalized(doc) {
  const { i18n } = useTranslation();
  return localizedDoc(doc, i18n.language);
}

export function useLocalizedField(doc, field) {
  const { i18n } = useTranslation();
  return localizedString(doc, field, i18n.language);
}
